module.exports = __webpack_public_path__ + "assets/txtsizefit.436be0e0.svg";